/* ============================================================
   SSUK Quote Builder
   localStorage-based quote cart with webhook submission
   ============================================================ */
(function () {
  'use strict';

  var STORAGE_KEY = 'ssuk_quote_cart';
  var WEBHOOK_URL = 'https://hook.eu1.make.com/v0usxte4tryr57m1w556arfckpo8eykn';

  /* --------------------------------------------------------
     Quote Cart — localStorage management
  -------------------------------------------------------- */
  var QuoteCart = {

    getItems: function () {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch (e) {
        return [];
      }
    },

    saveItems: function (items) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      this.updateBadge();
    },

    addItem: function (item) {
      var items = this.getItems();
      var existing = null;
      for (var i = 0; i < items.length; i++) {
        if (items[i].variantId === item.variantId) {
          existing = items[i];
          break;
        }
      }
      if (existing) {
        existing.quantity = (parseInt(existing.quantity) || 1) + (parseInt(item.quantity) || 1);
      } else {
        items.push(item);
      }
      this.saveItems(items);
      this.showToast(item);
    },

    removeItem: function (variantId) {
      var items = this.getItems().filter(function (i) {
        return i.variantId !== variantId;
      });
      this.saveItems(items);
    },

    updateQuantity: function (variantId, quantity) {
      var items = this.getItems();
      for (var i = 0; i < items.length; i++) {
        if (items[i].variantId === variantId) {
          items[i].quantity = parseInt(quantity) || 1;
          break;
        }
      }
      this.saveItems(items);
    },

    clear: function () {
      localStorage.removeItem(STORAGE_KEY);
      this.updateBadge();
    },

    getCount: function () {
      return this.getItems().reduce(function (total, item) {
        return total + (parseInt(item.quantity) || 1);
      }, 0);
    },

    updateBadge: function () {
      var count = this.getCount();
      document.querySelectorAll('.ssuk-quote-badge').forEach(function (badge) {
        badge.textContent = count;
        badge.style.display = count > 0 ? 'flex' : 'none';
      });
      document.querySelectorAll('[data-ssuk-quote-count]').forEach(function (el) {
        el.textContent = count;
      });
    },

    injectNavButton: function () {
      var cartIcon = document.getElementById('cart-icon');
      if (!cartIcon || document.getElementById('ssuk-quote-nav')) return;

      var count = this.getCount();
      var btn = document.createElement('a');
      btn.id = 'ssuk-quote-nav';
      btn.href = '/pages/quote';
      btn.className = 'header__icon relative text-current ssuk-quote-nav-btn';
      btn.setAttribute('aria-label', 'Quote request (' + count + ' items)');
      btn.innerHTML =
        /* SSUK, 09 Sept 2026. Duotone, from ssuk-icon-quote.svg, so the three header
           icons read as one set. Charcoal draws the clipboard, orange carries the
           tick. Stroke is 2.6/2.8 rather than the master's 1.6/1.7 because this
           renders at 24px on a 44 grid, where 1.6 resolves to under 0.9px. */
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" width="24" height="24" fill="none" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" class="icon icon--ssuk-duo">' +
          '<g stroke="var(--ssuk-charcoal, #343b43)" stroke-width="2.6">' +
            '<rect x="10" y="10" width="24" height="28" rx="2.5"></rect>' +
            '<path d="M16 10V7.5A2.5 2.5 0 0 1 18.5 5h7A2.5 2.5 0 0 1 28 7.5V10"></path>' +
          '</g>' +
          '<g stroke="var(--ssuk-orange, #e94e19)" stroke-width="2.8">' +
            '<path d="M16 23l3.5 3.5L27 19"></path>' +
            '<path d="M16 32h12"></path>' +
          '</g>' +
        '</svg>' +
        '<span class="ssuk-quote-badge" style="display:' + (count > 0 ? 'flex' : 'none') + '">' + count + '</span>';

      cartIcon.parentNode.insertBefore(btn, cartIcon);
    },

    /* -------------------------------------------------------
       Toast — white card with green left border
    ------------------------------------------------------- */
    showToast: function (item) {
      var existing = document.getElementById('ssuk-quote-toast');
      if (existing) {
        clearTimeout(existing._ssukTimer);
        existing.remove();
      }

      var count = this.getCount();
      var toast = document.createElement('div');
      toast.id = 'ssuk-quote-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML =
        '<div class="ssuk-toast__inner">' +
          '<div class="ssuk-toast__header">' +
            '<span class="ssuk-toast__check" aria-hidden="true">' +
              '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="var(--ssuk-green, #2b8138)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>' +
            '</span>' +
            '<span class="ssuk-toast__title">Added to your quote</span>' +
            '<button type="button" class="ssuk-toast__close js-ssuk-toast-close" aria-label="Dismiss notification">&#x2715;</button>' +
          '</div>' +
          '<p class="ssuk-toast__product">' + escHtml(item.productTitle) + '</p>' +
          '<div class="ssuk-toast__actions">' +
            '<a href="/pages/quote" class="ssuk-toast__view-link">View quote (<span data-ssuk-quote-count>' + count + '</span>) →</a>' +
            '<button type="button" class="ssuk-toast__continue js-ssuk-toast-close">Continue shopping</button>' +
          '</div>' +
          '<div class="ssuk-toast__progress"><div class="ssuk-toast__progress-bar"></div></div>' +
        '</div>';

      document.body.appendChild(toast);

      // Animate in
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          toast.classList.add('ssuk-quote-toast--visible');
        });
      });

      // Progress bar depletes over 4s
      var bar = toast.querySelector('.ssuk-toast__progress-bar');
      if (bar) {
        bar.style.width = '100%';
        requestAnimationFrame(function () {
          bar.style.transition = 'width 4s linear';
          bar.style.width = '0%';
        });
      }

      // Close handlers
      toast.querySelectorAll('.js-ssuk-toast-close').forEach(function (el) {
        el.addEventListener('click', function () { ssukDismissToast(toast); });
      });

      // Auto-dismiss
      toast._ssukTimer = setTimeout(function () { ssukDismissToast(toast); }, 4000);
    }
  };

  function ssukDismissToast(toast) {
    clearTimeout(toast._ssukTimer);
    toast.classList.remove('ssuk-quote-toast--visible');
    setTimeout(function () { if (toast.parentNode) toast.remove(); }, 350);
  }

  /* --------------------------------------------------------
     Product page — Add to Quote from dark strip
     Uses event delegation so it works after variant re-renders
  -------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ssuk-pdp-quote-btn]');
    if (!btn) return;

    var productForm = document.querySelector('.js-product-form-main');
    if (!productForm) return;

    var variantInput = productForm.querySelector('input[name="id"]');
    var variantId = variantInput ? variantInput.value : null;
    if (!variantId) {
      alert('Please select a variant before adding to quote.');
      return;
    }

    var qtyInput = productForm.querySelector('input[name="quantity"]');
    var quantity = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;

    // Product title
    var titleEl = document.querySelector('.product__title, h1.product-title, .product-info .title');
    var productTitle = titleEl ? titleEl.textContent.trim() : document.title.split('|')[0].trim();

    // Variant title from selected option labels
    var selectedValues = [];
    document.querySelectorAll('[data-selected-value], .variant-picker__option-value.is-selected').forEach(function (el) {
      var val = el.textContent.trim();
      if (val) selectedValues.push(val);
    });
    if (selectedValues.length === 0) {
      document.querySelectorAll('select[name*="option"]').forEach(function (s) {
        if (s.value) selectedValues.push(s.value);
      });
    }
    var variantTitle = selectedValues.join(' / ');

    // Product image
    var productImg = document.querySelector(
      '.product__media img, [data-media-type="image"] img, .product-media img, .product__image img'
    );
    var imageUrl = productImg ? productImg.src : '';

    // Lead time from strip
    var strip = document.querySelector('.ssuk-pdp-strip');
    var ltState = strip ? (strip.dataset.ltState || '') : '';
    var ltText = '';
    if (strip) {
      var ltValueEl = strip.querySelector('.ssuk-pdp-strip__lt-value');
      if (ltValueEl) ltText = ltValueEl.textContent.trim();
    }

    // Variant SKU — try multiple methods to be robust across Enterprise theme versions
    var sku = '';
    // Method 1: data attribute directly on a SKU element
    var skuAttrEl = document.querySelector('[data-variant-sku], [data-selected-sku], [data-sku]');
    if (skuAttrEl) {
      sku = skuAttrEl.dataset.variantSku || skuAttrEl.dataset.selectedSku || skuAttrEl.dataset.sku || '';
    }
    // Method 2: product JSON embedded in page — most reliable
    if (!sku) {
      var productJsonScript = document.querySelector('script[data-product-json], script[id="ProductJson"], script[type="application/json"][data-product-json]');
      if (productJsonScript) {
        try {
          var productJson = JSON.parse(productJsonScript.textContent || productJsonScript.innerHTML);
          var variantList = productJson.variants || [];
          for (var vi = 0; vi < variantList.length; vi++) {
            if (String(variantList[vi].id) === String(variantId)) {
              sku = variantList[vi].sku || '';
              break;
            }
          }
        } catch (skuErr) {}
      }
    }
    // Method 3: look for a visible SKU element on the page (e.g. "SKU: ABC123" or "| SKU: ABC123")
    if (!sku) {
      var skuDisplayEl = document.querySelector('.product__sku, [data-product-sku], .sku, .product-sku');
      if (skuDisplayEl) {
        // Extract just the code after any "SKU:" label, ignoring pipes and prefixes
        var skuMatch = skuDisplayEl.textContent.match(/SKU\s*[:.]?\s*([A-Za-z0-9][A-Za-z0-9\-_.]*)/i);
        if (skuMatch) sku = skuMatch[1].trim();
      }
    }

    QuoteCart.addItem({
      variantId: variantId,
      productTitle: productTitle,
      variantTitle: variantTitle,
      sku: sku,
      quantity: quantity,
      imageUrl: imageUrl,
      productUrl: window.location.href.split('?')[0],
      leadTimeState: ltState,
      leadTimeText: ltText
    });
  });

  /* --------------------------------------------------------
     Quote page — two-panel layout
  -------------------------------------------------------- */
  function renderQuotePage() {
    var container = document.getElementById('ssuk-quote-page');
    if (!container) return;

    /* Hide the Shopify page-level h1 ("Request a Quote") — the quote UI is self-contained */
    var pageH1 = document.querySelector('h1');
    if (pageH1 && !pageH1.closest('#ssuk-quote-page')) {
      pageH1.style.display = 'none';
    }

    function render() {
      var items = QuoteCart.getItems();

      /* Empty state */
      if (items.length === 0) {
        container.innerHTML =
          '<div class="ssuk-quote-empty">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="56" height="56" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
              '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>' +
              '<polyline points="14 2 14 8 20 8"/>' +
              '<line x1="16" y1="13" x2="8" y2="13"/>' +
              '<line x1="16" y1="17" x2="8" y2="17"/>' +
              '<polyline points="10 9 9 9 8 9"/>' +
            '</svg>' +
            '<p>Your quote list is empty.</p>' +
            '<a href="/collections/all" class="btn btn--primary">Browse products</a>' +
          '</div>';
        return;
      }

      var totalCount = items.reduce(function (t, i) { return t + (parseInt(i.quantity) || 1); }, 0);

      /* Header */
      var headerHtml =
        '<div class="ssuk-qp-header">' +
          '<div class="ssuk-qp-header__brand">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="var(--ssuk-green, #2b8138)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
              '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>' +
              '<polyline points="14 2 14 8 20 8"/>' +
              '<line x1="16" y1="13" x2="8" y2="13"/>' +
              '<line x1="16" y1="17" x2="8" y2="17"/>' +
              '<polyline points="10 9 9 9 8 9"/>' +
            '</svg>' +
            '<span class="ssuk-qp-header__title">Quote Request</span>' +
          '</div>' +
          '<div class="ssuk-qp-header__meta">' +
            '<span class="ssuk-qp-header__count">' + totalCount + ' item' + (totalCount !== 1 ? 's' : '') + '</span>' +
            '<span class="ssuk-qp-header__pill">' +
              '<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>' +
              'Quote back within 3 hours' +
            '</span>' +
          '</div>' +
        '</div>';

      /* Items list */
      var itemsHtml = items.map(function (item) {
        var img = item.imageUrl
          ? '<img src="' + escHtml(item.imageUrl) + '" alt="" loading="lazy" width="54" height="54">'
          : '<div class="ssuk-qp-item__img-ph"></div>';

        var ltHtml = '';
        if (item.leadTimeText) {
          ltHtml =
            '<span class="ssuk-qp-item__lt ssuk-qp-item__lt--' + escHtml(item.leadTimeState || 'contact') + '">' +
              '<span class="ssuk-qp-item__lt-dot" aria-hidden="true"></span>' +
              escHtml(item.leadTimeText) +
            '</span>';
        }

        return (
          '<div class="ssuk-qp-item" data-variant-id="' + escHtml(item.variantId) + '">' +
            '<div class="ssuk-qp-item__img">' + img + '</div>' +
            '<div class="ssuk-qp-item__info">' +
              '<a href="' + escHtml(item.productUrl) + '" class="ssuk-qp-item__title">' + escHtml(item.productTitle) + '</a>' +
              (item.variantTitle ? '<p class="ssuk-qp-item__variant">' + escHtml(item.variantTitle) + '</p>' : '') +
              ltHtml +
            '</div>' +
            '<div class="ssuk-qp-item__stepper">' +
              '<button type="button" class="ssuk-qp-stepper__btn ssuk-qp-stepper__dec" data-variant-id="' + escHtml(item.variantId) + '" aria-label="Decrease quantity">−</button>' +
              '<input type="number" class="ssuk-qp-stepper__input" value="' + item.quantity + '" min="1" data-variant-id="' + escHtml(item.variantId) + '" aria-label="Quantity">' +
              '<button type="button" class="ssuk-qp-stepper__btn ssuk-qp-stepper__inc" data-variant-id="' + escHtml(item.variantId) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="ssuk-qp-item__remove" data-variant-id="' + escHtml(item.variantId) + '" aria-label="Remove ' + escHtml(item.productTitle) + ' from quote">' +
              '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>' +
            '</button>' +
          '</div>'
        );
      }).join('');

      /* Form panel */
      var formHtml =
        '<div class="ssuk-qp-form-panel">' +
          '<h2 class="ssuk-qp-form-panel__heading">Your Details</h2>' +
          '<form id="ssuk-quote-form" class="ssuk-quote-form" novalidate>' +

            '<div class="ssuk-quote-form__row ssuk-quote-form__row--2col">' +
              '<div class="ssuk-quote-form__field">' +
                '<label for="quote-name">Full name <span aria-hidden="true">*</span></label>' +
                '<input type="text" id="quote-name" name="name" required autocomplete="name" placeholder="Jane Smith">' +
              '</div>' +
              '<div class="ssuk-quote-form__field">' +
                '<label for="quote-company">Company</label>' +
                '<input type="text" id="quote-company" name="company" autocomplete="organization" placeholder="Smith Civil Ltd">' +
              '</div>' +
            '</div>' +

            '<div class="ssuk-qp-reply-toggle">' +
              '<span class="ssuk-qp-reply-toggle__label">Preferred reply method</span>' +
              '<div class="ssuk-qp-reply-toggle__options">' +
                '<label class="ssuk-qp-reply-option"><input type="radio" name="replyPreference" value="Email" checked> Email</label>' +
                '<label class="ssuk-qp-reply-option"><input type="radio" name="replyPreference" value="Phone"> Phone</label>' +
                '<label class="ssuk-qp-reply-option"><input type="radio" name="replyPreference" value="Either"> Either</label>' +
              '</div>' +
            '</div>' +

            '<div class="ssuk-quote-form__row ssuk-quote-form__row--2col">' +
              '<div class="ssuk-quote-form__field">' +
                '<label for="quote-email">Email address <span aria-hidden="true">*</span></label>' +
                '<input type="email" id="quote-email" name="email" required autocomplete="email" placeholder="jane@company.com">' +
              '</div>' +
              '<div class="ssuk-quote-form__field">' +
                '<label for="quote-phone">Phone number</label>' +
                '<input type="tel" id="quote-phone" name="phone" autocomplete="tel" placeholder="01234 567890">' +
              '</div>' +
            '</div>' +

            '<div class="ssuk-quote-form__field">' +
              '<label for="quote-address">Delivery address</label>' +
              '<input type="text" id="quote-address" name="deliveryStreet" autocomplete="street-address" placeholder="Street address">' +
            '</div>' +
            '<div class="ssuk-quote-form__row ssuk-quote-form__row--2col">' +
              '<div class="ssuk-quote-form__field">' +
                '<input type="text" name="deliveryTown" autocomplete="address-level2" placeholder="Town / City">' +
              '</div>' +
              '<div class="ssuk-quote-form__field">' +
                '<input type="text" name="deliveryPostcode" autocomplete="postal-code" placeholder="Postcode">' +
              '</div>' +
            '</div>' +

            '<div class="ssuk-quote-form__field">' +
              '<label for="quote-logistics">Logistics / site access notes</label>' +
              '<textarea id="quote-logistics" name="logistics" rows="3" placeholder="Access restrictions, timescales, or delivery notes…"></textarea>' +
            '</div>' +

            '<div class="ssuk-quote-form__field">' +
              '<label for="quote-message">Additional notes</label>' +
              '<textarea id="quote-message" name="message" rows="3" placeholder="Any other requirements…"></textarea>' +
            '</div>' +

            '<div class="ssuk-quote-form__field ssuk-quote-form__field--gdpr">' +
              '<label class="ssuk-quote-gdpr">' +
                '<input type="checkbox" id="quote-gdpr" name="gdpr" required>' +
                '<span>I agree to Street Solutions UK processing my data to respond to this enquiry. We will not share your data with third parties. View our <a href="/pages/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>. <span aria-hidden="true">*</span></span>' +
              '</label>' +
            '</div>' +

            '<div class="ssuk-quote-form__actions">' +
              '<button type="submit" class="ssuk-quote-form__submit btn btn--primary">Request Your Quote</button>' +
              '<p class="ssuk-quote-form__note">* Required. Or call: <a href="tel:01617060479">0161 706 0479</a></p>' +
            '</div>' +

          '</form>' +
        '</div>';

      /* Assemble */
      container.innerHTML =
        headerHtml +
        '<div class="ssuk-qp-body">' +
          '<div class="ssuk-qp-items-panel">' +
            '<div class="ssuk-qp-items">' + itemsHtml + '</div>' +
            '<div id="ssuk-upsell" class="ssuk-qp-upsell" aria-label="You might also need"></div>' +
            '<div class="ssuk-qp-bottom">' +
              '<a href="/collections/all" class="ssuk-qp-add-more">← Add more products</a>' +
            '</div>' +
          '</div>' +
          formHtml +
        '</div>';

      /* Async: fetch Shopify recommendations for first cart item */
      (function () {
        if (!items.length || !items[0].productUrl) return;
        var rawHandle = items[0].productUrl.split('/products/')[1];
        if (!rawHandle) return;
        var handle = rawHandle.split('?')[0].split('#')[0];

        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (product) {
            return fetch('/recommendations/products.json?product_id=' + product.id + '&limit=5&intent=related');
          })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var upsellEl = document.getElementById('ssuk-upsell');
            if (!upsellEl || !data.products || data.products.length === 0) return;

            var cardsHtml = data.products.map(function (p) {
              var imgSrc = p.featured_image
                ? p.featured_image.replace(/(\.[a-z]+)$/i, '_160x160$1')
                : '';
              var imgHtml = imgSrc
                ? '<img src="' + imgSrc + '" alt="" loading="lazy" width="80" height="80">'
                : '<div class="ssuk-upsell-card__img-ph"></div>';
              var exVat = p.price_min
                ? '£' + (p.price_min / 120).toFixed(2) + ' Ex. VAT'
                : '';
              return (
                '<a href="' + p.url + '" class="ssuk-upsell-card">' +
                  '<div class="ssuk-upsell-card__img">' + imgHtml + '</div>' +
                  '<p class="ssuk-upsell-card__title">' + escHtml(p.title) + '</p>' +
                  (exVat ? '<p class="ssuk-upsell-card__price">' + exVat + '</p>' : '') +
                '</a>'
              );
            }).join('');

            upsellEl.innerHTML =
              '<p class="ssuk-qp-upsell__heading">You might also need</p>' +
              '<div class="ssuk-qp-upsell__track">' + cardsHtml + '</div>';
          })
          .catch(function () {}); /* Fail silently — upsell is non-critical */
      }());

      /* Stepper events */
      container.querySelectorAll('.ssuk-qp-stepper__dec').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = this.dataset.variantId;
          var current = QuoteCart.getItems().filter(function (i) { return i.variantId === id; })[0];
          if (current) {
            var newQty = Math.max(1, (parseInt(current.quantity) || 1) - 1);
            QuoteCart.updateQuantity(id, newQty);
            render();
          }
        });
      });
      container.querySelectorAll('.ssuk-qp-stepper__inc').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = this.dataset.variantId;
          var current = QuoteCart.getItems().filter(function (i) { return i.variantId === id; })[0];
          if (current) {
            QuoteCart.updateQuantity(id, (parseInt(current.quantity) || 1) + 1);
            render();
          }
        });
      });
      container.querySelectorAll('.ssuk-qp-stepper__input').forEach(function (input) {
        input.addEventListener('change', function () {
          var qty = parseInt(this.value);
          if (qty > 0) {
            QuoteCart.updateQuantity(this.dataset.variantId, qty);
          } else {
            this.value = 1;
            QuoteCart.updateQuantity(this.dataset.variantId, 1);
          }
        });
      });

      /* Remove events */
      container.querySelectorAll('.ssuk-qp-item__remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          QuoteCart.removeItem(this.dataset.variantId);
          render();
        });
      });

      /* Form submit */
      var form = container.querySelector('#ssuk-quote-form');
      if (form) {
        form.addEventListener('submit', function (e) {
          handleFormSubmit(e, render);
        });
      }
    }

    render();
  }

  /* --------------------------------------------------------
     Form submission
  -------------------------------------------------------- */
  function handleFormSubmit(e, renderFn) {
    e.preventDefault();
    var form = e.target;

    /* Clear previous errors */
    form.querySelectorAll('.ssuk-quote-error').forEach(function (el) {
      el.classList.remove('ssuk-quote-error');
    });
    var errorBanner = form.querySelector('.ssuk-quote-form-error');
    if (errorBanner) errorBanner.remove();

    var nameInput  = form.querySelector('[name="name"]');
    var emailInput = form.querySelector('[name="email"]');
    var gdprInput  = form.querySelector('[name="gdpr"]');
    var valid = true;

    if (!nameInput.value.trim()) { nameInput.classList.add('ssuk-quote-error'); valid = false; }
    if (!emailInput.value.trim() || !emailInput.value.includes('@')) { emailInput.classList.add('ssuk-quote-error'); valid = false; }
    if (!gdprInput.checked) { gdprInput.closest('.ssuk-quote-form__field--gdpr').classList.add('ssuk-quote-error'); valid = false; }

    if (!valid) {
      showFormError(form, 'Please fill in all required fields and agree to the privacy policy.');
      return;
    }

    var submitBtn = form.querySelector('[type="submit"]');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending…';

    var replyPref = form.querySelector('[name="replyPreference"]:checked');
    var g = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? el.value.trim() : ''; };

    var cartItems = QuoteCart.getItems();

    /* Pre-format items for Make.com email — the raw array renders as blank in templates */
    var itemsHtml = cartItems.length > 0
      ? '<table style="width:100%;border-collapse:collapse;font-family:sans-serif;font-size:14px;margin-top:4px">' +
        cartItems.map(function (item) {
          return (
            '<tr style="border-bottom:1px solid #eee">' +
              '<td style="padding:10px 10px 10px 0;width:32px;font-weight:700;color:#1a2533;vertical-align:top">' + escHtml(String(item.quantity)) + '&times;</td>' +
              '<td style="padding:10px 0;vertical-align:top">' +
                '<strong style="color:#1a2533">' + escHtml(item.productTitle) + '</strong>' +
                (item.variantTitle ? '<br><span style="color:var(--ssuk-grey, #6b747e);font-size:13px">' + escHtml(item.variantTitle) + '</span>' : '') +
                (item.sku ? '<br><span style="color:var(--ssuk-grey, #6b747e);font-size:12px;font-family:monospace">SKU: ' + escHtml(item.sku) + '</span>' : '') +
                (item.leadTimeText ? '<br><span style="color:var(--ssuk-amber, #b45309);font-size:12px">' + escHtml(item.leadTimeText) + '</span>' : '') +
              '</td>' +
              '<td style="padding:10px 0 10px 10px;text-align:right;vertical-align:top">' +
                '<a href="https://www.streetsolutionsuk.com' + escHtml(item.productUrl || '') + '" style="color:var(--ssuk-green, #2b8138);font-size:12px;text-decoration:none">View&nbsp;product&nbsp;›</a>' +
              '</td>' +
            '</tr>'
          );
        }).join('') +
        '</table>'
      : '<p style="color:var(--ssuk-grey, #6b747e);font-size:13px">No items recorded.</p>';

    var itemsText = cartItems.map(function (item) {
      var line = item.quantity + ' x ' + item.productTitle;
      if (item.variantTitle) line += ' (' + item.variantTitle + ')';
      if (item.sku) line += ' [SKU: ' + item.sku + ']';
      if (item.leadTimeText) line += ' — ' + item.leadTimeText;
      return line;
    }).join('\n');

    var payload = {
      name:             nameInput.value.trim(),
      company:          g('company'),
      replyPreference:  replyPref ? replyPref.value : 'Email',
      email:            emailInput.value.trim(),
      phone:            g('phone'),
      deliveryStreet:   g('deliveryStreet'),
      deliveryTown:     g('deliveryTown'),
      deliveryPostcode: g('deliveryPostcode'),
      logistics:        g('logistics'),
      message:          g('message'),
      gdpr:             true,
      items:            cartItems,
      itemsHtml:        itemsHtml,
      itemsText:        itemsText,
      source:           window.location.href
    };

    fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Server error ' + res.status);
        var name = payload.name.split(' ')[0];
        QuoteCart.clear();
        var container = document.getElementById('ssuk-quote-page');
        if (container) {
          container.innerHTML =
            '<div class="ssuk-quote-success">' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="56" height="56" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>' +
              '<h2>Quote Request Sent</h2>' +
              '<p>Thanks ' + escHtml(name) + ', we’ve received your enquiry and will be in touch shortly.</p>' +
              '<p class="ssuk-quote-success__sub">In the meantime, call us on <a href="tel:01617060479">0161 706 0479</a> if you need anything urgently.</p>' +
              '<a href="/collections/all" class="btn btn--secondary">Continue Shopping</a>' +
            '</div>';
        }
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Request Your Quote';
        showFormError(form, 'Something went wrong. Please try again or call us on 0161 706 0479.');
      });
  }

  function showFormError(form, message) {
    var el = document.createElement('p');
    el.className = 'ssuk-quote-form-error';
    el.textContent = message;
    form.prepend(el);
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function escHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* --------------------------------------------------------
     Init
  -------------------------------------------------------- */
  function init() {
    QuoteCart.injectNavButton();
    renderQuotePage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
